// Site-wide brand and contact info.

export const LOGO_URL =
  "https://customer-assets-jt897jd0.emergentagent.net/wingman/9895e16b-8404-4820-b934-3100c7eb0dd7/attachments/684e71704e0a4b9ea91c11f3220cc109_image.bin";

export const EA_BADGE_URL =
  "https://customer-assets-jt897jd0.emergentagent.net/wingman/9895e16b-8404-4820-b934-3100c7eb0dd7/attachments/06f4289497dd4a3ca21760941732cb9c_image.bin";

export const COMPANY = {
  legalName: "Waites Painting & Decorating",
  tradingName: "Waites Clearances",
  address: {
    line1: "Oundle Marina, Barnwell Road",
    line2: "Oundle, Peterborough, PE8 5PY",
  },
  phoneDisplay: "07761 748698",
  phoneTel: "+447761748698",
  email: "waitesclearance@gmail.com",
  wasteCarrierLicence: "CBDU662542",
};
